import FloatingVue from 'floating-vue';
import { defineAppPlugin } from '/app/utils/app';

import 'floating-vue/dist/style.css';

export default defineAppPlugin(({ app }) => {
    app.use(FloatingVue, {
        // Safari-specific configuration
        handleResize: false, // Disable resize handling that causes issues in Safari
        themes: {
            tooltip: {
              // Delay (ms)
              delay: {
                show: 100,
                hide: 0,
              },
              distance: 8,
              instantMove: true,
              html: true,
            },
            dropdown: {
              distance: 8,
              disposeTimeout: 10,
            },
            details:{
                $extend: 'tooltip',
                $resetCss: true,
            },
            alert:{
                $extend: 'tooltip',
                $resetCss: true,
            },
            helper:{
                $extend: 'tooltip',
                $resetCss: true
            },
            tip:{
                $extend: 'dropdown',
                $resetCss: true
            },
            info:{
                $extend: 'dropdown',
                $resetCss: true
            },
            raw:{
                $extend: 'tooltip',
                $resetCss: true
            },
            dust:{
                $extend: 'tooltip',
                $resetCss: true
            },
            report:{
                $extend: 'dropdown',
                $resetCss: true,
                disposeTimeout: 0,
                distance: 0,
            },
            menu:{
                $extend: 'dropdown',
                $resetCss: true,
                disposeTimeout: 0,
                distance: 0,
            },
            note:{
                $extend: 'tooltip',
                $resetCss: true
            },
            nerve:{
                $extend: 'tooltip',
            },
            danger:{
                $extend: 'tooltip',
            },
            'danger-alert':{
                $extend: 'tooltip',
            },
            bubble:{
                $extend: 'tooltip',
                $resetCss: true,
                delay: {
                    show: 0,
                    hide: 0,
                },
                distance: 10,
                instantMove: true,
                triggers: [],
                arrowPadding: 0,
                arrowOverflow: false,
                showArrow: false,
                // The popper recomputes its position on every scroll while
                // shown. Flipping placement mid-flight would jump the bubble
                // across its own target, so pin it.
                flip: false,
            },
          },
    });
})
